<template>
  <div class="box has-text-centered content is-medium">
    <h2>Congratulations!<br>You graduated to {{planLabel}}</h2>

      <p class="mb-0"><img src="/img/scholar.gif"></p>
      <p>You are awesome! Keep going.</p>
      <p class="has-text-centered">
        <a class="button is-success is-medium" href="/dashboard"
          >To Dashboard</a
        >
      </p>

  </div>
</template>

<script>
export default {
  name: "UpgradeSuccessForm",
  props: [
    "planLabel"
  ],
  data: function () {
    return {
    };
  },
  mounted: function () {

  },
  methods: {
  },
};
</script>

<style scoped lang="scss">

</style>